/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

/**
 * Linkify filter.
 * @author Yakob Abada <yabada@frontier.co.uk>
 * @param {string} inputText
 *
 * @return {string}
 */
export default (inputText: string): string => {
    // URLs starting with http://, https://, or ftp://
    const replacePattern1: RegExp = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    let replacedText: string = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

    // URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    const replacePattern2: RegExp = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

    // Change email addresses to mailto:: links.
    const replacePattern3: RegExp = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
    replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

    return replacedText;
};
